import {UntypedFormArray, Validators} from '@angular/forms';

export class EmploymentDetailsModel {
  employmentList = {
    value: [],
    validation: Validators.compose([]),
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class EmploymentGroupsModel {
  currentEmployments = {
    value: [],
    validation: Validators.compose([]),
  };
  previousEmployments = {
    value: [],
    validation: Validators.compose([]),
  };
  otherIncomes = {
    value: [],
    validation: Validators.compose([]),
  };
  nonTaxableIncomes = {
    value: [],
    validation: Validators.compose([]),
  };
}

export class IndividualEmploymentModel {
  currentEmployments = { // uses SingleEmploymentModel
    value: [],
    validation: Validators.compose([])
  };
  previousEmployments = {
    value: [], // uses SingleEmploymentModel
    validation: Validators.compose([])
  };
  familyAllowance = {
    value: 0,
    validation: Validators.compose([
      Validators.required
    ])
  };
  familyAllowanceFrequency = {
    value: 'monthly',
    validation: Validators.compose([
      Validators.required
    ])
  };
  otherIncome = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0)
    ])
  };
  otherIncomeFrequency = {
    value: 'monthly',
    validation: Validators.compose([
      Validators.required
    ])
  };
}

export class SingleEmploymentModel {
  anzsicCategory = {
    value: '',
    validation: Validators.compose([])
  };
  employer = {
    value: '',
    validation: Validators.compose([Validators.required])
  };
  occupation = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  currencyType = {
    value: 'current',
    validation: Validators.compose([Validators.required])
  };
  category = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  status = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  validBasis = {
    value: [],
    validation: Validators.compose([])
  };
  requireIncomes = {
    value: false,
    validation: Validators.compose([])
  };
  basis = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  probation = {
    value: null,
    validation: Validators.compose([])
  };
  lengthYears = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.max(100)
    ])
  };
  lengthMonths = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.max(11)
    ])
  };
  incomes = {
    value: [],
    validation: Validators.compose([])
  };
  abnAcnNumber = {
    value: null,
    validation: Validators.compose([])
  };
  businessType = {
    value: null,
    validation: Validators.compose([])
  };
  with =  {
    value: null,
    validation: Validators.compose([])
  };
  percentage =  {
    value: null,
    validation: Validators.compose([])
  };
  partnershipType = {
    value: null,
    validation: Validators.compose([])
  };
  partnerships = {
    value: null,
    validation: Validators.compose([])
  };
  previousYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  previousYearTotalIncome = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  currentYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  currentYearTotalIncome = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  allowableAddBacks = {
    value: [],
    validation: Validators.compose([])
  };
  link = {
    value: null,
    validation: Validators.compose([]),
    disabled: true
  };
  parent = {
    value: true,
    validation: Validators.compose([]),
    disabled: true
  };
}

export class SinglePreviousEmploymentModel {
  anzsicCategory = {
    value: '',
    validation: Validators.compose([])
  };
  employer = {
    value: '',
    validation: Validators.compose([Validators.required])
  };
  occupation = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  currencyType = {
    value: 'previous',
    validation: Validators.compose([Validators.required])
  };
  category = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  status = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  basis = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  probation = {
    value: null,
    validation: Validators.compose([])
  };
  lengthYears = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.max(100)
    ])
  };
  lengthMonths = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.max(11)
    ])
  };
}

export class BasicIncomeModel {
  type = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  frequency = {
    value: 'annually',
    validation: Validators.compose([Validators.required])
  };
  amount = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.pattern('^[0-9\.]*$'),
    ])
  };
}

export class SelfEmployedIncomeModel {
  abnAcnNumber = {
    value: null,
    validation: Validators.compose([])
  };
  businessType = {
    value: null,
    validation: Validators.compose([])
  };
  with =  {
    value: null,
    validation: Validators.compose([])
  };
  percentage =  {
    value: null,
    validation: Validators.compose([])
  };
  partnershipType = {
    value: null,
    validation: Validators.compose([])
  };
  partnerships = {
    value: [],
    validation: Validators.compose([])
  };
  previousYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  previousYearTotalIncome = {
    value: null,
    validation: Validators.compose([])
  };
  currentYearIncome = {
    value: null,
    validation: Validators.compose([])
  };
  currentYearTotalIncome = {
    value: null,
    validation: Validators.compose([])
  };
  allowableAddBacks = {
    value: [],
    validation: Validators.compose([])
  };
}

export class SelfEmployedAddbackModel {
  addbackLink = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  addbackType = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  addbackDescription = {
    value: null,
    validation: Validators.compose([])
  };
  addbackCurrentYearIncome = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
  addbackPreviousYearIncome = {
    value: null,
    validation: Validators.compose([Validators.required])
  };
}

export class SelfEmployedPartnershipsModel {
  with =  {
    value: null,
    validation: Validators.compose([])
  };
  percentage =  {
    value: null,
    validation: Validators.compose([])
  };
}
